module.exports = __webpack_public_path__ + "static/img/sevens_office_logo.32e7c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/sevens_office_logo.png
// module id = Gibf
// module chunks = 2